import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {DeviceEventService} from "../../../../services/device-event.service";
import {AbstractProdGrid, IProdGrid, MercureEvent, ProdGridColumnTransforms, ProdGridColumnType} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {ProdDialogData} from 'prod-dialog';
import {DipColumn} from "../../../../dip/dip-column";
import {BatteryEventsForm} from "./battery-events-form/battery-events-form";
import {RoleService} from "../../../../services/role.service";
import {Role} from "../../../../dip/role";
import {MercureService} from "../../../mercure/mercure.service";
import {Md5} from "ts-md5";
import {MercureTopic} from "../../../mercure/mercure-topic";
import {OrganizationTreeSelect} from "../../../../dip/organization-tree-select";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-battery-events-grid',
  templateUrl: './battery-events-grid.component.html'
})
export class BatteryEventsGridComponent extends AbstractProdGrid implements IProdGrid, OnInit {
  @Input() dialogData: ProdDialogData;
  prodGridTitle: string = this.translate.instant('cars.battery_events.grid_title');
  isAddButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_CAR_BATTERY_EVENT_EDIT]);
  isEditButtonShown: boolean = !this.roleService.hasRole([Role.ROLE_CAR_BATTERY_EVENT_EDIT]);
  isRemoveButtonDisabled: boolean = !this.roleService.hasRole([Role.ROLE_CAR_BATTERY_EVENT_DELETE]);
  override prodGridForm = {
    component: BatteryEventsForm
  };
  prodGridColumns: DipColumn[] = [
    DipColumn.get({
      property: 'createdAt',
      type: ProdGridColumnType.DATE,
      transform: {
        transform: ProdGridColumnTransforms.DATETIME
      }
    }),
    DipColumn.get({
      property: 'batteryEvent.voltage',
      type: ProdGridColumnType.NUMBER,
      postfix: 'V',
      transform: {
        transform: ProdGridColumnTransforms.ZERO_PADDING,
        option: 3
      }
    }),
    DipColumn.get({
      property: 'type.name',
      type: ProdGridColumnType.STRING,
    }),
    DipColumn.get({
      property: 'batteryEvent.description',
      type: ProdGridColumnType.STRING,
    })
  ];

  constructor(
    protected override changeDetectorRef: ChangeDetectorRef,
    override prodGridDataService: DeviceEventService,
    private roleService: RoleService,
    private mercureService: MercureService,
    private organizationTreeSelect: OrganizationTreeSelect,
    private translate: TranslateService
  ) {
    super(changeDetectorRef);
  }

  override ngOnInit() {
    super.ngOnInit();
    const md5 = new Md5();

    const companies: number[] = [];
    this.dialogData.data.records.getAll().forEach(car => {
      if (car.equipment.organization.organization) {
        companies.push(car.equipment.organization.organization.id);
      }
    });

    companies.map(id => {
      this.mercureService.subscribe(md5.appendStr(`${MercureTopic.DeviceEvent}${id}`).end().toString()).onmessage = e => this.inputAction$.emit(new MercureEvent([]));
      this.mercureService.subscribe(md5.appendStr(`${MercureTopic.EntityChanged}${id}`).end().toString()).onmessage = e => this.inputAction$.emit(new MercureEvent([]));
    });
  }

  ngOnDestroy(): void {
    this.mercureService.unsubscribe();
  }

  override loadProdGridData(httpExtraParams?: HttpExtraParams): void {
    let devices: number[] = [];
    let cars: number[] = [];
    if (this.dialogData.data.records) {
      this.dialogData.data.records.getAll().forEach(car => {
        const dongle = car.equipment.devices.filter(d => d.deviceType.name === 'DONGLE');
        if (dongle.length === 1) {
          devices.push(dongle[0].id);
        }

        cars.push(car.equipment.id);
      });
    }

    super.loadProdGridData(
      HttpExtraParams.addFilter(
        httpExtraParams,
        [
          devices.length === 0 ? null : new HttpFilterParam({property: 'device.id', operator: 'in', value: devices}),
          new HttpFilterParam({property: 'equipment.id', operator: 'in', value: cars})
        ].concat(this.organizationTreeSelect.getHttpExtraParams(this.prodGridDataService)).filter(f => f)
      )
    );
  }
}
